import Typography from '@mui/material/Typography';
import styled from '@mui/system/styled';

export const StyledText = styled(Typography)(({ theme }) => ({
  fontSize: '14px',
  lineHeight: '22px',
}));
export const StyledTextSub = styled(Typography)(({ theme }) => ({
  color: theme.palette.grey[500],
  fontSize: '12px',
  lineHeight: '16px',
}));
export const StyledTextSubNoColor = styled(Typography)(({ theme }) => ({
  fontSize: '12px',
  lineHeight: '16px',
}));
